const WS_SCOPE_VALUES = new Set(["lsp", "stt"]);

const getApiBaseUrl = () => process.env.REACT_APP_BASE_API_URL || "";

export function getWsBaseUrl() {
  const baseUrl = getApiBaseUrl();
  if (!baseUrl) return "";

  try {
    const url = new URL(baseUrl);
    url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
    url.pathname = "";
    url.search = "";
    url.hash = "";
    return url.toString().replace(/\/$/, "");
  } catch {
    return "";
  }
}

export async function createWsTicket(evaluationId, scope) {
  if (!evaluationId) {
    throw new Error("Missing evaluation_id for WS ticket");
  }
  if (!WS_SCOPE_VALUES.has(scope)) {
    throw new Error(`Invalid WS ticket scope: ${scope}`);
  }

  const apiBase = getApiBaseUrl();
  if (!apiBase) {
    throw new Error("API base URL not configured");
  }

  const headers = {
    "Content-Type": "application/json",
  };

  const accessToken = localStorage.getItem("access_token");
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const response = await fetch(`${apiBase}/ws/ticket`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      evaluation_id: evaluationId,
      scope,
    }),
  });

  if (!response.ok) {
    throw new Error(`Ticket request failed: ${response.status}`);
  }

  const payload = await response.json();
  if (!payload?.ws_token) {
    throw new Error("Ticket response missing ws_token");
  }

  return payload;
}
